/**
 * Priority gambling GEO chips shown inline in the sub-account popup
 * (App Service `GEO_PRIORITY_WEIGHTS` / DAI-1168). Order is the UI order.
 */
export const PRIORITY_GAMBLING_GEOS = [
	"UA",
	"PL",
	"DE",
	"IT",
	"FR",
	"ES",
	"DK",
	"SE",
	"NL",
	"GB",
] as const;

export type PriorityGamblingGeo = (typeof PRIORITY_GAMBLING_GEOS)[number];
